import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAxios } from "../../../api/axios";
import { useTranslation } from "react-i18next";

export const useAddNotes = (
  onSuccess?: void | ((data: any) => void),
  onError?: void | ((error: any) => void)
) => {
  const queryClient = useQueryClient();
  const axios = useAxios();
  const { t } = useTranslation();
  return useMutation({
    mutationFn: async (data: {
      pubPropertyId: string;
      accountId: string;
      isPrivate: boolean;
      notes: string;
    }) => {
      const response = await axios.post(t("notes"), data);
      return response.data;
    },
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data);
      }
      queryClient.invalidateQueries({ queryKey: ["notes-list"] });
      // queryClient.setQueriesData(
      //   { queryKey: ["notes-list"] },
      //   (oldData: any) => {
      //     if (!oldData) return oldData;
      //     return [...oldData, data.data];
      //   }
      // );
    },
    onError: (err) => {
      if (onError) {
        onError(err);
      }
    }
  });
};
